import { config } from '@/config/config';
import { fetchWithCheck } from '@/utils/fetch';

const apiUrl = config.apiBaseUrl;

export const api = {
  /**
   * @param {string} path
   * @param {RequestInit?} options
   * @returns {Promise<Response>}
   */
  get(path, options = {}) {
    return fetchWithCheck(apiUrl + path, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      ...options,
    });
  },

  /**
   * @param {string} path
   * @param {unknown} body
   * @param {RequestInit?} options
   * @returns {Promise<Response>}
   */
  post(path, body, options = {}) {
    return fetchWithCheck(apiUrl + path, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      ...options,
    });
  },
};
